/* ==========================================================================
   MOUILLETTE · theme.js
   Vanilla JS, sin dependencias. Módulos: analítica, drawers, carrito AJAX,
   búsqueda predictiva, test de perfume, pestañas, filtros, producto, WhatsApp.
   ========================================================================== */
(() => {
  'use strict';

  const MOU = window.MOU || { routes: {}, settings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const imgW = (url, w) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=${w}` : '');
  const esc = (str) => String(str ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- Analítica (lista para GA4 / Meta / TikTok vía dataLayer) ---------------- */
  const trackEvent = (name, payload = {}) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
      document.dispatchEvent(new CustomEvent('mou:track', { detail: { name, payload } }));
    } catch (e) { /* nunca romper la compra */ }
  };
  window.MOU.trackEvent = trackEvent;
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-track]');
    if (t) trackEvent(t.dataset.track, { context: t.dataset.trackContext || '' });
  });

  /* ---------------- Formato de dinero ---------------- */
  const formatMoney = (cents) => {
    const fmt = MOU.settings.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';
    const value = Number(cents) / 100;
    const withSep = (n, dec, thou, decSep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? decSep + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withSep(value, 2, ',', '.');
        case 'amount_no_decimals': return withSep(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(value, 2, "'", '.');
        default: return withSep(value, 0, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  };

  /* ---------------- Header ---------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(`Drawer-${id}`);
    if (!d) return;
    lastFocus = document.activeElement;
    $$('[data-drawer].is-open').forEach((o) => o !== d && closeDrawer(o));
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    const panel = $('.drawer__panel', d);
    panel.removeAttribute('inert');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => ($('[data-autofocus]', d) || panel).focus(), 40);
    document.dispatchEvent(new CustomEvent(`mou:drawer:${id}`));
  };
  const closeDrawer = (d) => {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $('.drawer__panel', d).setAttribute('inert', '');
    if (!$$('[data-drawer].is-open').length) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  window.MOU.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-drawer]'));
    if (e.target.closest('[data-quiz-open]')) {
      e.preventDefault();
      openDrawer('quiz');
    }
  });
  document.addEventListener('keydown', (e) => {
    const open = $('[data-drawer].is-open');
    if (!open) return;
    if (e.key === 'Escape') closeDrawer(open);
    if (e.key === 'Tab') {
      const f = $$('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])', $('.drawer__panel', open)).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Carrito ---------------- */
  const Cart = {
    state: null,
    async fetch() {
      const r = await fetch(`${MOU.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      this.state = await r.json();
      this.render();
      return this.state;
    },
    async add(variantId, qty = 1, source = '') {
      const r = await fetch(`${MOU.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'No se pudo añadir');
      const item = data.items && data.items[0];
      trackEvent('add_to_cart', { item_id: item?.product_id, item_name: item?.product_title, price: (item?.price || 0) / 100, currency: 'COP', source });
      await this.fetch();
      const countEl = $('.header__cart');
      if (countEl) { countEl.classList.remove('is-bump'); void countEl.offsetWidth; countEl.classList.add('is-bump'); }
      return data;
    },
    async change(key, quantity) {
      const r = await fetch(`${MOU.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      this.state = await r.json();
      if (quantity === 0) trackEvent('remove_from_cart', { key });
      this.render();
    },
    wholesaleHTML(count) {
      const min = Number(MOU.settings.wholesaleMin) || 6;
      const ok = count >= min;
      const missing = min - count;
      const pct = Math.min(100, Math.round((count / min) * 100));
      const txt = ok
        ? `<strong>Tu pedido califica para precio al por mayor.</strong> ${esc(MOU.settings.wholesaleNote || '')}`
        : `Te ${missing === 1 ? 'falta' : 'faltan'} <strong>${missing} ${missing === 1 ? 'perfume' : 'perfumes'}</strong> para precio al por mayor.`;
      return `<div class="wsp${ok ? ' is-ok' : ''}"><div class="wsp__row"><p class="wsp__txt">${txt}</p><span class="wsp__n">${Math.min(count, min)}/${min}</span></div><div class="wsp__bar" aria-hidden="true"><span style="width:${pct}%"></span></div></div>`;
    },
    render() {
      const c = this.state;
      if (!c) return;
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      const qty = $('[data-cart-qty]');
      if (qty) qty.textContent = c.item_count ? `(${c.item_count})` : '';
      const body = $('[data-cart-body]');
      const foot = $('[data-cart-foot]');
      if (!body) return;
      if (!c.items.length) {
        body.innerHTML = $('#CartEmptyTpl').innerHTML;
        foot.hidden = true;
        return;
      }
      foot.hidden = false;
      $('[data-cart-subtotal]').textContent = formatMoney(c.total_price);
      $('[data-cart-wholesale]').innerHTML = this.wholesaleHTML(c.item_count);
      body.innerHTML = `<ul class="cart__lines">${c.items.map((it) => {
        const img = it.image ? `<img src="${esc(imgW(it.image, 240))}" alt="" loading="lazy" width="84" height="105">` : '';
        const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<p class="cline__meta">${esc(it.variant_title)}</p>` : '';
        return `<li class="cline" data-key="${esc(it.key)}">
          <a href="${esc(it.url)}" class="cline__img" tabindex="-1" aria-hidden="true">${img}</a>
          <div class="cline__info">
            <p class="cline__brand">${esc(it.vendor)}</p>
            <p class="cline__name"><a href="${esc(it.url)}">${esc(it.product_title)}</a></p>
            ${variant}
            <div class="cline__ctrl">
              <div class="stepper" role="group" aria-label="Cantidad de ${esc(it.product_title)}">
                <button type="button" data-qty="${it.quantity - 1}" aria-label="${it.quantity === 1 ? 'Quitar' : 'Restar uno'}">−</button>
                <span aria-live="polite">${it.quantity}</span>
                <button type="button" data-qty="${it.quantity + 1}" aria-label="Sumar uno">+</button>
              </div>
              <button type="button" class="textbtn" data-qty="0">Quitar</button>
            </div>
          </div>
          <span class="price">${formatMoney(it.final_line_price)}</span>
        </li>`;
      }).join('')}</ul>`;
    },
  };
  window.MOU.Cart = Cart;

  document.addEventListener('mou:drawer:cart', () => {
    Cart.fetch();
    trackEvent('view_cart');
  });
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-cart-body] [data-qty]');
    if (q) {
      const key = q.closest('[data-key]').dataset.key;
      q.disabled = true;
      await Cart.change(key, Math.max(0, Number(q.dataset.qty)));
    }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      try {
        await Cart.add(quick.dataset.variantId, 1, quick.dataset.source || 'card');
        quick.classList.add('is-added');
        const label = $('.pcard__add-label', quick);
        if (label) label.textContent = 'Añadido';
        openDrawer('cart');
      } catch (err) {
        alertInline(quick, err.message);
      } finally {
        setTimeout(() => { quick.disabled = false; }, 600);
      }
    }
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-cart-page-form]');
    if (form) return;
    if (e.submitter && e.submitter.name === 'checkout') trackEvent('begin_checkout');
  });

  const alertInline = (el, msg) => {
    const p = document.createElement('p');
    p.className = 'form-error';
    p.setAttribute('role', 'alert');
    p.textContent = msg;
    el.insertAdjacentElement('afterend', p);
    setTimeout(() => p.remove(), 4000);
  };

  /* ---------------- Página de producto ---------------- */
  const pdp = $('[data-product-page]');
  if (pdp) {
    const form = $('[data-product-form]', pdp);
    const variants = JSON.parse($('[data-variants]', pdp)?.textContent || '[]');
    const idInput = $('[data-variant-id]', pdp);
    const btn = $('[data-add-button]', pdp);
    const priceEl = $('[data-price]', pdp);
    const priceMini = $('[data-price-mini]', pdp);

    trackEvent('view_item', { item_id: pdp.dataset.productId });

    // Galería
    $$('[data-thumb]', pdp).forEach((t) => t.addEventListener('click', () => showSlide(Number(t.dataset.thumb))));
    const showSlide = (i) => {
      $$('[data-slide]', pdp).forEach((s) => { const on = Number(s.dataset.slide) === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', String(!on)); });
      $$('[data-thumb]', pdp).forEach((t) => { const on = Number(t.dataset.thumb) === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
    };

    // Variantes
    $$('[data-option-index]', pdp).forEach((input) => input.addEventListener('change', () => {
      const selected = $$('[data-option-index]:checked', pdp).map((i) => i.value);
      const v = variants.find((x) => x.options.every((o, idx) => o === selected[idx]));
      $$('.pdp__option .pill', pdp).forEach((l) => l.classList.toggle('is-on', $('input', l).checked));
      if (!v) { btn.disabled = true; btn.textContent = 'No disponible'; return; }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (priceMini) priceMini.textContent = formatMoney(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      if (v.featured_media) {
        const slide = $(`[data-media-id="${v.featured_media.id}"]`, pdp);
        if (slide) showSlide(Number(slide.dataset.slide));
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }));

    // Añadir al carrito
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.disabled = true;
      const original = btn.textContent;
      try {
        await Cart.add(idInput.value, 1, 'pdp');
        btn.classList.add('is-added');
        btn.textContent = 'Añadido a tu selección';
        openDrawer('cart');
      } catch (err) {
        alertInline(btn, err.message);
      } finally {
        setTimeout(() => { btn.disabled = false; btn.classList.remove('is-added'); btn.textContent = original; }, 1800);
      }
    });

    // Barra fija móvil
    const buybar = $('[data-buybar]', pdp);
    if (buybar && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        buybar.classList.toggle('is-visible', show);
        buybar.setAttribute('aria-hidden', String(!show));
        $('[data-buybar-add]', buybar).tabIndex = show ? 0 : -1;
        document.body.classList.toggle('has-buybar', show);
      }).observe(btn);
      $('[data-buybar-add]', buybar).addEventListener('click', () => form.requestSubmit());
    }
  }

  /* ---------------- Recomendaciones ---------------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const inner = tmp.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch (e) { /* silencio */ }
  });

  /* ---------------- Página de carrito ---------------- */
  $$('[data-cart-page-qty]').forEach((input) => input.addEventListener('change', () => input.form.requestSubmit(input.form.querySelector('[name="update"]'))));

  /* ---------------- Búsqueda predictiva ---------------- */
  const sInput = $('[data-predictive-input]');
  if (sInput) {
    const results = $('[data-search-results]');
    const suggest = $('[data-search-suggest]');
    let timer;
    let controller;
    const run = async (q) => {
      if (!q.trim()) { results.innerHTML = ''; suggest.hidden = false; return; }
      suggest.hidden = true;
      controller?.abort();
      controller = new AbortController();
      try {
        const url = `${MOU.routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body`;
        const data = await (await fetch(url, { signal: controller.signal })).json();
        const products = data?.resources?.results?.products || [];
        trackEvent('search', { search_term: q, results: products.length });
        if (!products.length) {
          results.innerHTML = '<div class="search__empty"><p class="search__empty-title">No apareció por ahí.</p><p>Prueba con una nota, una marca o una sensación.</p></div>';
          return;
        }
        results.innerHTML = `<p class="search__count">${products.length} ${products.length === 1 ? 'perfume' : 'perfumes'}</p><ul class="search__results">${products.map((p) => `
          <li><a class="sresult" href="${esc(p.url)}">
            <span class="sresult__img">${p.featured_image?.url ? `<img src="${esc(imgW(p.featured_image.url, 160))}" alt="" loading="lazy">` : ''}</span>
            <span class="sresult__txt"><span class="sresult__brand">${esc(p.vendor)}</span><span class="sresult__name">${esc(p.title)}</span><span class="sresult__why">${esc(p.product_type || '')}</span></span>
            <span class="price">${formatMoney(Math.round(parseFloat(p.price) * 100))}</span>
          </a></li>`).join('')}</ul>
          <a class="linkarrow search__all" href="${MOU.routes.search}?q=${encodeURIComponent(q)}&type=product">Ver todos los resultados</a>`;
      } catch (e) { /* abortado */ }
    };
    sInput.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(() => run(sInput.value), 220); });
    $$('[data-search-chip]').forEach((c) => c.addEventListener('click', () => { sInput.value = c.dataset.searchChip; run(sInput.value); sInput.focus(); }));
  }

  /* ---------------- Pestañas (destacados y guía) ---------------- */
  $$('[data-tabs]').forEach((root) => {
    const tabs = $$('[role="tab"][data-tab]', root);
    const select = (id, focus) => {
      tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      $$('[data-panel]', root).forEach((p) => { p.hidden = p.dataset.panel !== id; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t.dataset.tab));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        select(n.dataset.tab, true);
      });
    });
  });

  /* ---------------- Filtros de colección (AJAX con Section Rendering) ---------------- */
  const initFacets = () => {
    const plp = $('[data-plp]');
    if (!plp) return;
    const sectionId = plp.dataset.sectionId;
    const form = $('[data-facets-form]', plp);
    const panel = $('[data-filters-panel]', plp);

    const open = () => { plp.classList.add('filters-open'); document.documentElement.style.overflow = 'hidden'; };
    const close = () => { plp.classList.remove('filters-open'); document.documentElement.style.overflow = ''; };
    plp.addEventListener('click', (e) => {
      if (e.target.closest('[data-filters-open]')) open();
      if (e.target.closest('[data-filters-close]')) close();
    });

    const render = async (url, push = true) => {
      plp.classList.add('is-loading');
      const sep = url.includes('?') ? '&' : '?';
      const html = await (await fetch(`${url}${sep}section_id=${sectionId}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('ProductGridContainer');
      const newPanel = doc.getElementById('FiltersPanel');
      if (newGrid) $('#ProductGridContainer', plp).replaceWith(newGrid);
      if (newPanel) {
        const wasOpen = plp.classList.contains('filters-open');
        $('#FiltersPanel', plp).replaceWith(newPanel);
        bindForm();
        if (wasOpen) plp.classList.add('filters-open');
      }
      if (push) history.pushState({ facets: true }, '', url);
      plp.classList.remove('is-loading');
      trackEvent('filter_apply', { url });
    };

    const toUrl = () => {
      const f = $('[data-facets-form]', plp);
      const params = new URLSearchParams(new FormData(f));
      const sortSel = $('[data-sort-select]', plp);
      if (sortSel && window.matchMedia('(min-width: 1024px)').matches) params.set('sort_by', sortSel.value);
      for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
      return `${window.location.pathname}?${params.toString()}`;
    };

    let t;
    const bindForm = () => {
      const f = $('[data-facets-form]', plp);
      f.addEventListener('input', (e) => {
        if (e.target.matches('[data-sort-radio]')) $$('.pill', f).forEach((l) => l.classList.toggle('is-on', $('input', l).checked));
        clearTimeout(t);
        t = setTimeout(() => render(toUrl()), e.target.type === 'number' ? 600 : 150);
      });
      f.addEventListener('submit', (e) => { e.preventDefault(); render(toUrl()); });
    };
    bindForm();
    plp.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort-select]')) {
        const params = new URLSearchParams(new FormData($('[data-facets-form]', plp)));
        params.set('sort_by', e.target.value);
        render(`${window.location.pathname}?${params.toString()}`);
      }
    });
    plp.addEventListener('click', (e) => {
      const a = e.target.closest('[data-facet-link]');
      if (a) { e.preventDefault(); render(a.getAttribute('href')); }
    });
    window.addEventListener('popstate', () => render(window.location.href, false));
    trackEvent('view_category', { collection: window.location.pathname });
  };
  initFacets();

  /* ---------------- WhatsApp flotante ---------------- */
  const wa = $('[data-wa]');
  if (wa) {
    const card = $('[data-wa-card]', wa);
    const msg = wa.dataset.message;
    if (msg) {
      $('[data-wa-preview]', wa).textContent = `«${msg}»`;
      $('[data-wa-link]', wa).href = `https://wa.me/${MOU.settings.whatsapp}?text=${encodeURIComponent(msg)}`;
    }
    $$('[data-wa-toggle]', wa).forEach((b) => b.addEventListener('click', () => {
      card.hidden = !card.hidden;
      wa.classList.toggle('is-open', !card.hidden);
      $('.wa__btn', wa).setAttribute('aria-expanded', String(!card.hidden));
    }));
    $('[data-wa-link]', wa).addEventListener('click', () => trackEvent('whatsapp_click', { context: 'float' }));
    const onScroll = () => wa.classList.toggle('is-compact', window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (document.body.classList.contains('template-product')) wa.classList.add('wa--raised');
  }

  /* ---------------- Reveal discreto ---------------- */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('is-pending'); io.observe(el); }
      else el.classList.add('is-in');
    });
  }

  /* ==========================================================================
     TEST DE PERFUME
     ========================================================================== */
  const quizRoot = $('[data-quiz-root]');
  const quizData = (() => { try { return JSON.parse($('#QuizProducts')?.textContent || '[]'); } catch (e) { return []; } })();

  const STEPS = [
    { key: 'who', q: '¿Para quién es el perfume?', help: 'Si es un regalo, lo tenemos en cuenta para que aciertes.', options: [
      ['ella', 'Para mí · ella'], ['el', 'Para mí · él'], ['regalo-ella', 'Un regalo para ella'], ['regalo-el', 'Un regalo para él'], ['cualquiera', 'Me da igual', 'Muéstrame lo que mejor me quede']] },
    { key: 'climate', q: '¿En qué clima lo vas a usar?', help: 'El calor multiplica lo dulce y lo denso. El frío lo apaga. Esto cambia todo.', options: [
      ['caliente', 'Tierra caliente', 'Barranquilla, Cartagena, Cali, Santa Marta'], ['templado', 'Clima templado', 'Medellín, Pereira, Bucaramanga'], ['frio', 'Clima frío', 'Bogotá, Tunja, Manizales'], ['viajo', 'Me muevo entre climas']] },
    { key: 'occasion', q: '¿Dónde lo vas a usar más?', help: 'Piensa en el plan donde más quieres oler bien.', options: [
      ['diario', 'Todos los días', 'Un perfume que funcione para todo'], ['oficina', 'Oficina y reuniones', 'Que se note, sin invadir'], ['noche', 'Salidas de noche', 'Rumba, conciertos, planes largos'], ['cita', 'Citas', 'Que te recuerden de cerca'], ['eventos', 'Eventos especiales', 'Matrimonios, cenas, grados']] },
    { key: 'likes', multi: 2, exclusive: 'nose', q: '¿Qué olores te gustan?', help: 'Elige hasta 2. Piensa en cosas reales, no en perfumes.', options: [
      ['fresco', 'Recién bañado', 'Limón, mar, menta, jabón limpio'], ['dulce', 'Postre', 'Vainilla, caramelo, chocolate, café con leche'], ['floral', 'Flores', 'Rosa, jazmín, flores blancas'], ['madera', 'Madera y cuero', 'Cedro, sándalo, tabaco, vetiver'], ['especiado', 'Especias y ámbar', 'Canela, pimienta, incienso'], ['nose', 'No sé todavía', 'Recomiéndenme ustedes']] },
    { key: 'dislikes', multi: 3, exclusive: 'nada', q: '¿Qué NO soportas en un perfume?', help: 'Tan importante como lo que te gusta. Puedes marcar varias.', options: [
      ['muy-dulce', 'Que sea empalagoso'], ['muy-floral', 'Que huela a flores'], ['muy-fuerte', 'Que sea muy fuerte', 'Me duele la cabeza o incomoda a otros'], ['nada', 'Nada en especial']] },
    { key: 'effect', q: '¿Qué quieres transmitir?', help: 'Lo que alguien pensaría de ti al olerte.', options: [
      ['frescura', 'Limpio y fresco'], ['dulzura', 'Cálido y cercano'], ['elegancia', 'Elegante y pulido'], ['misterio', 'Misterioso y seductor'], ['presencia', 'Seguro, que se note']] },
    { key: 'presence', q: '¿Qué tan fuerte lo quieres?', help: 'Íntimo se descubre de cerca. Con estela se queda en el cuarto cuando te vas.', options: [
      ['sutil', 'Íntimo', 'Solo quien se acerca lo nota'], ['notorio', 'Notorio', 'Se siente en la mesa'], ['estela', 'Que deje estela', 'Llega antes que tú y se queda']] },
    { key: 'budget', q: '¿Cuánto quieres invertir?', help: 'Todos son de alta concentración.', options: [
      ['lt150', 'Hasta $150.000'], ['150-200', '$150.000 – $200.000'], ['gt200', 'Más de $200.000'], ['igual', 'Lo que mejor me quede']] },
  ];
  const BUDGET = { lt150: [0, 15000000], '150-200': [15000001, 20000000], gt200: [20000001, Infinity] };

  const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const hasFam = (p, ...f) => (p.families || []).some((x) => f.map(norm).includes(norm(x)));
  const intensityKey = (p) => { const n = norm(p.intensity); return n.includes('estela') ? 'estela' : n.includes('intima') ? 'intima' : n.includes('notoria') ? 'notoria' : ''; };
  const momentKey = (p) => { const n = norm(p.moment); return n.includes('noche') ? 'noche' : n.includes('dia') ? 'dia' : n ? 'versatil' : ''; };
  const effects = (p) => (p.effects || []).map(norm);
  const isSweet = (p) => hasFam(p, 'Gourmand', 'Dulce');
  const isFloral = (p) => hasFam(p, 'Floral');
  const isFresh = (p) => hasFam(p, 'Fresca', 'Aromática', 'Cítrica');
  const isWarm = (p) => hasFam(p, 'Ámbar', 'Especiada', 'Gourmand', 'Dulce');
  const LIKE = { fresco: isFresh, dulce: isSweet, floral: isFloral, madera: (p) => hasFam(p, 'Amaderada', 'Aromática'), especiado: (p) => hasFam(p, 'Ámbar', 'Especiada') };
  const LIKE_WORD = { fresco: 'lo fresco', dulce: 'lo dulce', floral: 'las flores', madera: 'la madera', especiado: 'las especias' };
  const INT = ['intima', 'notoria', 'estela'];
  const PRES = { sutil: 'intima', notorio: 'notoria', estela: 'estela' };

  const evaluate = (p, a) => {
    let s = 0; let max = 0; const why = []; let caveat;
    const ik = intensityKey(p); const mk = momentKey(p); const ef = effects(p);
    if (a.climate) {
      max += 3;
      if (a.climate === 'caliente') {
        if (isFresh(p) && ik !== 'estela') { s += 3; why.push('Aguanta el calor sin volverse pesado'); }
        else if (isFresh(p)) s += 2;
        else if (isWarm(p) && ik === 'estela') { s += 0.5; caveat = 'En tierra caliente, con 2 atomizaciones basta. Mejor de noche.'; }
        else s += 1.5;
      } else if (a.climate === 'frio') {
        if (isWarm(p)) { s += 3; why.push('Brilla en clima frío: el calor de tu piel lo abre'); }
        else if (isFresh(p)) { s += 1.5; caveat = 'En frío, los frescos se sienten más tímidos. Aplica en ropa.'; }
        else s += 2;
      } else if (a.climate === 'templado') { s += mk === 'versatil' ? 3 : 2.2; if (mk === 'versatil') why.push('Se adapta al clima templado de día y de noche'); }
      else { s += mk === 'versatil' ? 3 : 1.8; if (mk === 'versatil') why.push('Funciona igual en tierra caliente que en frío'); }
    }
    if (a.occasion) {
      max += 3; let pts = 0; const o = a.occasion;
      if (o === 'diario') pts = mk === 'versatil' ? 3 : ik !== 'estela' ? 2 : 1;
      if (o === 'oficina') pts = ik === 'estela' ? 0.5 : mk !== 'noche' ? 3 : 1.5;
      if (o === 'noche') pts = mk === 'noche' ? 3 : ik === 'estela' ? 2.2 : 1;
      if (o === 'cita') pts = ef.some((e) => e === 'misterio' || e === 'dulzura') ? 3 : ef.includes('elegancia') ? 2 : 1;
      if (o === 'eventos') pts = ef.some((e) => e === 'elegancia' || e === 'presencia') ? 3 : 1.5;
      s += pts;
      if (pts >= 3) why.push({ diario: 'Sirve para el día a día sin cansar', oficina: 'Correcto para la oficina: se nota sin invadir', noche: 'Hecho para la noche y los planes largos', cita: 'De los que se recuerdan de cerca', eventos: 'Tiene la presencia que pide un evento' }[o]);
      if (o === 'oficina' && ik === 'estela') caveat = caveat || 'Para oficina, úsalo con una sola atomización.';
    }
    const likes = a.likes.filter((l) => l !== 'nose');
    if (likes.length) {
      max += 4; const hits = likes.filter((l) => LIKE[l](p));
      s += (hits.length / likes.length) * 4;
      if (hits.length) why.push(`Tiene ${hits.map((h) => LIKE_WORD[h]).join(' y ')} que te gusta`);
    } else if (a.likes.includes('nose')) { max += 4; s += p.favorite ? 4 : 2.5; if (p.favorite) why.push('Es de los más elegidos: un acierto seguro'); }
    if (a.dislikes.includes('muy-dulce') && isSweet(p)) s -= 4;
    if (a.dislikes.includes('muy-floral') && isFloral(p)) s -= 4;
    if (a.dislikes.includes('muy-fuerte')) { if (ik === 'estela') s -= 3; else if (ik === 'intima') why.push('Suave: no incomoda a nadie'); }
    if (a.effect) { max += 3; if (ef.includes(a.effect)) { s += 3; why.push({ frescura: 'Transmite limpieza y frescura', dulzura: 'Se siente cálido y cercano', elegancia: 'Se lee elegante y pulido', misterio: 'Tiene un fondo misterioso', presencia: 'Proyecta seguridad' }[a.effect]); } }
    if (a.presence && ik) { max += 3; const d = Math.abs(INT.indexOf(ik) - INT.indexOf(PRES[a.presence])); s += d === 0 ? 3 : d === 1 ? 1.2 : 0; }
    if (a.budget && a.budget !== 'igual') {
      max += 2; const [lo, hi] = BUDGET[a.budget];
      if (p.price >= lo && p.price <= hi) { s += 2; why.push('Está dentro de tu presupuesto'); } else s += 0.6;
    }
    if (!p.available) s -= 5;
    return { p, score: Math.max(0, s) - p.rank * 0.01, max: max || 1, why: why.slice(0, 3), caveat };
  };

  const PROFILE = { frescura: ['Fresco', 'Te gusta oler limpio, ligero y actual. Tu perfume ideal acompaña sin robarse la escena.'], dulzura: ['Cálido', 'Buscas un perfume que abrace. Cercano, cálido y fácil de querer.'], elegancia: ['Elegante', 'Prefieres lo pulido. Un perfume que se lea adulto, seguro y bien vestido.'], misterio: ['Nocturno', 'Te atrae lo que no se explica del todo. Fondo oscuro, piel y un poco de intriga.'], presencia: ['Magnético', 'Quieres que se note cuando llegas. Proyección, carácter y horas en la piel.'] };
  const PRES_WORD = { sutil: 'de cercanía', notorio: 'de presencia', estela: 'de estela' };

  const Quiz = {
    step: 0,
    a: { likes: [], dislikes: [] },
    reset() { this.step = 0; this.a = { likes: [], dislikes: [] }; },
    render() {
      if (!quizRoot) return;
      if (this.step >= STEPS.length) return this.renderResult();
      const st = STEPS[this.step];
      const val = this.a[st.key];
      const isOn = (v) => (Array.isArray(val) ? val.includes(v) : val === v);
      const pct = Math.round((this.step / STEPS.length) * 100);
      const canNext = Array.isArray(val) ? val.length > 0 : Boolean(val);
      const left = STEPS.length - this.step;
      quizRoot.innerHTML = `<div class="ptest">
        <div class="ptest__bar"><span>Pregunta ${this.step + 1} de ${STEPS.length}</span><span>${left <= 2 ? 'Ya casi' : `≈ ${Math.max(1, Math.ceil(left * 0.25))} min`}</span></div>
        <div class="ptest__progress" role="progressbar" aria-valuenow="${pct}" aria-valuemin="0" aria-valuemax="100"><span style="width:${pct}%"></span></div>
        <fieldset class="ptest__step">
          <legend class="ptest__q">${st.q}</legend>
          <p class="ptest__help">${st.help}</p>
          <div class="ptest__opts ${st.options.length > 4 ? 'ptest__opts--grid' : ''}">
            ${st.options.map(([v, label, hint], i) => `<button type="button" class="popt ${isOn(v) ? 'is-on' : ''}" aria-pressed="${isOn(v)}" data-opt="${v}" ${i === 0 ? 'data-autofocus' : ''}>
              <span class="popt__txt"><span class="popt__label">${label}</span>${hint ? `<span class="popt__hint">${hint}</span>` : ''}</span>
              <span class="popt__mark" aria-hidden="true">${isOn(v) ? '✓' : ''}</span></button>`).join('')}
          </div>
        </fieldset>
        <div class="ptest__nav">
          <button type="button" class="textbtn" data-quiz-back ${this.step === 0 ? 'disabled' : ''}>Atrás</button>
          ${st.multi ? `<button type="button" class="btn btn--dark" data-quiz-next ${canNext ? '' : 'disabled'}>Siguiente →</button>` : '<span class="ptest__auto">Elige una opción para continuar</span>'}
        </div>
      </div>`;
    },
    choose(v) {
      const st = STEPS[this.step];
      if (st.multi) {
        let arr = [...this.a[st.key]];
        if (v === st.exclusive) arr = arr.includes(v) ? [] : [v];
        else { arr = arr.filter((x) => x !== st.exclusive); arr = arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v].slice(-st.multi); }
        this.a[st.key] = arr;
        this.render();
      } else {
        this.a[st.key] = v;
        this.render();
        setTimeout(() => this.next(), 240);
      }
    },
    next() {
      if (this.step === STEPS.length - 1) trackEvent('quiz_complete', { ...this.a, likes: this.a.likes.join(','), dislikes: this.a.dislikes.join(',') });
      this.step += 1;
      this.render();
      quizRoot.closest('.drawer__body')?.scrollTo(0, 0);
    },
    renderResult() {
      const a = this.a;
      const pool = quizData.filter((p) => {
        if (a.who === 'ella' || a.who === 'regalo-ella') return p.gender !== 'el';
        if (a.who === 'el' || a.who === 'regalo-el') return p.gender !== 'ella';
        return true;
      });
      const res = pool.map((p) => evaluate(p, a)).sort((x, y) => y.score - x.score).slice(0, 3);
      const [pname, pcopy] = PROFILE[a.effect || 'elegancia'];
      const profile = `${pname} ${PRES_WORD[a.presence || 'notorio']}`;
      const label = (k) => STEPS.find((s) => s.key === k)?.options.find((o) => o[0] === a[k])?.[1];
      const chips = ['climate', 'occasion', 'presence', 'budget'].map(label).filter(Boolean);
      const gift = String(a.who || '').startsWith('regalo');
      const waMsg = `Hola, Mouillette. Hice el test y me salió el perfil "${profile}". Me recomendaron: ${res.map((r) => r.p.title).join(', ')}. ¿Cuál me recomiendan?`;
      quizRoot.innerHTML = `<div class="ptest ptest--result">
        <header class="presult__head">
          <div class="presult__profile">
            <p class="eyebrow eyebrow--gold">Tu perfil olfativo</p>
            <p class="presult__name">${profile}</p>
            <p class="presult__copy">${pcopy}</p>
            <ul class="presult__chips">${chips.map((c) => `<li>${c}</li>`).join('')}</ul>
          </div>
          <div class="presult__intro">
            <p class="presult__title">${gift ? 'Con estos aciertas.' : 'Estos son para ti.'}</p>
            <p>Ordenados por afinidad con tus respuestas. Si dudas entre dos, escríbenos y te decimos cuál.</p>
          </div>
        </header>
        ${res.length ? `<ol class="presult__list">${res.map((r, i) => {
          const pct = Math.min(98, Math.round((r.score / r.max) * 100));
          const img = r.p.image ? `<img src="${esc(r.p.image)}" alt="" loading="lazy">` : '';
          return `<li class="prec ${i === 0 ? 'prec--top' : ''}">
            <a href="${esc(r.p.url)}" class="prec__img" tabindex="-1" aria-hidden="true">${img}${i === 0 ? '<span class="prec__flag">Tu mejor opción</span>' : ''}</a>
            <div class="prec__body">
              <div class="prec__top">
                <div><p class="prec__brand">${esc(r.p.vendor)}</p><p class="prec__name">${esc(r.p.title)}</p></div>
                <div class="affinity" aria-label="${pct}% de afinidad"><svg viewBox="0 0 36 36" aria-hidden="true"><circle cx="18" cy="18" r="15.5" class="affinity__track"/><circle cx="18" cy="18" r="15.5" class="affinity__bar" stroke-dasharray="${(pct / 100) * 97.4} 97.4"/></svg><span>${pct}%</span></div>
              </div>
              ${r.p.micro ? `<p class="prec__micro">${esc(r.p.micro)}</p>` : ''}
              <ul class="prec__why">${r.why.map((w) => `<li><span aria-hidden="true">✓</span> ${w}</li>`).join('')}</ul>
              ${r.caveat ? `<p class="prec__caveat"><strong>Ten en cuenta:</strong> ${r.caveat}</p>` : ''}
              <div class="prec__buy">
                <span class="price price--lg">${esc(r.p.priceFormatted)}</span>
                <div class="prec__actions">
                  <a href="${esc(r.p.url)}" class="btn btn--line">Ver perfume</a>
                  ${r.p.available && !r.p.multiVariant ? `<button type="button" class="btn btn--dark" data-quick-add data-variant-id="${r.p.id}" data-source="quiz">Añadir al carrito</button>` : `<a href="${esc(r.p.url)}" class="btn btn--dark">Elegir</a>`}
                </div>
              </div>
            </div>
          </li>`;
        }).join('')}</ol>` : '<p>Aún no hay perfumes configurados para el test. Revisa la colección del test en Configuración del tema.</p>'}
        <div class="presult__foot">
          ${MOU.settings.whatsapp ? `<a class="btn btn--gold btn--lg" href="https://wa.me/${MOU.settings.whatsapp}?text=${encodeURIComponent(waMsg)}" target="_blank" rel="noopener noreferrer" data-track="whatsapp_click" data-track-context="quiz_result">Confirmar con un asesor</a>` : ''}
          <button type="button" class="textbtn" data-quiz-restart>Repetir el test</button>
        </div>
      </div>`;
    },
  };

  if (quizRoot) {
    document.addEventListener('mou:drawer:quiz', () => {
      if (Quiz.step === 0 || Quiz.step >= STEPS.length) { Quiz.reset(); trackEvent('quiz_start'); }
      Quiz.render();
    });
    quizRoot.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-opt]');
      if (opt) Quiz.choose(opt.dataset.opt);
      if (e.target.closest('[data-quiz-back]')) { Quiz.step = Math.max(0, Quiz.step - 1); Quiz.render(); }
      if (e.target.closest('[data-quiz-next]')) Quiz.next();
      if (e.target.closest('[data-quiz-restart]')) { Quiz.reset(); Quiz.render(); }
    });
  }

  /* ---------------- Carga inicial del contador ---------------- */
  if (document.readyState !== 'loading') trackEvent('page_view_mou', { template: document.body.className });
})();
